import React from 'react';
import {
  BiometricSettingsConnectorApollo,
  GoalSettingsValidateConnectorApollo,
  SaveUserDataConnectorApollo,
} from '@front-activerse/common-components';
import BiometricSettingsContainer from './BiometricSettingsContainer';
import { IRoute } from '@front-activerse/common-components';

interface IGoalSettingsPage {
  descendantRoutes: IRoute[];
}

const GoalSettingsIndexPage: React.FC<IGoalSettingsPage> = ({ descendantRoutes }) => {
  return (
    <BiometricSettingsConnectorApollo>
      {({ ...biometricSettingsData }) => (
        <SaveUserDataConnectorApollo>
          {({ saveUserData }) => (
            <GoalSettingsValidateConnectorApollo>
              {({ validateGoalSettings }) => (
                <BiometricSettingsContainer
                  descendantRoutes={descendantRoutes}
                  {...biometricSettingsData}
                  saveUserData={saveUserData}
                  //validateGoalSettings={validateGoalSettings}
                />
              )}
            </GoalSettingsValidateConnectorApollo>
          )}
        </SaveUserDataConnectorApollo>
      )}
    </BiometricSettingsConnectorApollo>
  );
};

export default GoalSettingsIndexPage;
